












































































































































import { Component, Vue, Ref } from 'vue-property-decorator'
import { VueCsvImport } from 'vue-csv-import'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import { FindImportacaoUseCase } from '@/usecases'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'

@Component({
	components: {
		VueCsvImport,
	},
})
export default class DialogoDeCsvProdutos extends Vue {
	@Ref() csvComponent!: VueCsvImport

	findImportacaoUseCase = new FindImportacaoUseCase()

	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
	];
	csv: any[] | null = null
	tipoLayout: string | null = null
	loading = false
	hasHeaders = true
	inputFile: HTMLInputElement | null = null
	hover= false

	camposCsvProdutos = {
		sku: 'sku',
		eans: 'eans',
		nome: 'nome',
		descricao: 'descricao',
		ncm: 'ncm',
		tags: 'tags',
		tipo: 'tipo',
		marca: 'marca',
		preco: 'preco',
		genero: 'genero',
		categoria: 'categoria',
		urlsImagens: 'urls_imagens',
		unidadeMedida: 'unidade_medida',
		tamanho: 'tamanho',
		cor: 'cor',
	}

	get arquivoSelecionado() {
		if((this.csvComponent && this.csvComponent.fileSelected) || (this.inputFile && this.inputFile.value)){
			return "Arquivo selecionado, favor definir colunas"
		}
		return "Nenhum arquivo selecionado"
	}

	async mostrar() {
		this.mostra = true
	}

	cancelar() {
		this.csv = null
		this.mostra = false
		if (this.csvComponent) {
			this.csvComponent.sample = null
			this.csvComponent.fileSelected = false
			this.csvComponent.map = []
		}
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async concluirImportacao() {
		this.loading = true
		
		if(!this.usuario) return

		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
				this.loading = false
				return
			}
		}

		try {
			const file = this.csvComponent.file || this.inputFile?.files?.[0]
			if (!file) throw new Error('Nenhum arquivo selecionado!')
			const resultado = await uploadFilesToS3([file], 'produtos-csv')
			this.$emit('concluiuImportacao', resultado[0].config.url?.split('?')[0], this.hasHeaders)
			this.cancelar()
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.loading = false
		}
	}

	async baixarModelo() {
		const rows = [
			[
				'referencia','sku','eans','nome','descricao','ncm','tags','tipo','marca','preco','genero','categoria','urls_imagens','unidade_medida','tamanho','cor',
			],
			[
				'ABC123','ABC123GGBRANCO','123456789,987654321','Exemplo Produto Com Variantes 1','Uma descrição informativa','62046200','TAG1,TAG2','COM_VARIANTES','MARCA1','0.00','MASCULINO','CATEGORIA1','http://exemplo.com/imagens/exemplo_1.jpg','UN','GG','BRANCO',
			],
			[
				'ABC123','ABC123GGPRETO','678912345,432198765','Exemplo Produto Com Variantes 2','Uma descrição informativa','62046200','TAG1,TAG2','COM_VARIANTES','MARCA1','0.00','MASCULINO','CATEGORIA1','http://exemplo.com/imagens/exemplo_2.jpg','UN','GG','PRETO',
			],
			[
				'','789XYZ','789456123','Exemplo Produto Padrao','Uma descrição informativa','62046200','TAG1,TAG2','PADRAO','MARCA2','0.00','MASCULINO','CATEGORIA2','http://exemplo.com/imagens/exemplo_3.jpg','UN','','',
			],
		]

		const csvContent = "data:text/csv;charset=utf-8," 
			+ rows.map(e => e.join(";")).join("\n")

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement("a")
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", "modelo_importacao_produto.csv")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	clickCsv() {
		this.inputFile = document.querySelector('.form-control-file')
		if(this.inputFile != null)
			this.inputFile.click()
		
	}
}
